import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyAsXse_QfNXoBTtxdnF0nGgjuEY7iROfxs",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "political-issues-platform.firebaseapp.com",
  projectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID || "political-issues-platform",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "political-issues-platform.appspot.com",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "82074311864",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:82074311864:web:2cca22b10fd3cbae45e84d",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Disable reCAPTCHA for Replit and Localhost (Development Only)
if (
  window.location.hostname.includes("replit") ||
  window.location.hostname === "localhost"
) {
  auth.settings.appVerificationDisabledForTesting = true;
}

export { auth };
